import styled, { css } from 'styled-components';
import { IconButton } from 'modules/IconButton';
import { pxToRem } from 'modules/spacing';
import { interactiveTransition, theme } from 'modules/tetrisTheme';
export const YEARS_PER_ROW = 4;
const selectedDayStyles = css `
  background-color: ${theme.semantic.surface.inverse};
  color: ${theme.semantic.foreground.inverse};
`;
const selectedYearStyles = css `
  background-color: ${theme.semantic.surface.inverse};
  color: ${theme.semantic.foreground.inverse};
`;
const fadedDayStyles = css `
  color: ${theme.semantic.foreground.disabled};
`;
const todayStyle = css `
  background-color: ${theme.swatches.gray[100]};
`;
export const Container = styled.div `
  display: inline-flex;
  width: 100%;

  &:focus-visible {
    outline: 0;
  }
`;
export const Column = styled.div `
  overflow: hidden;
  width: 100%;
`;
// Use div container because buttons and flex don't play well together
export const DayContainer = styled.div `
  font-size: ${theme.fontSize.small};
  line-height: ${theme.lineHeight.none};
  flex: 0 0 ${100 / 7}%;
  display: flex;
  justify-content: center;
  align-items: center;

  &::before {
    content: '';
    padding-top: 100%;
  }
`;
export const DayButton = styled.button.attrs(() => ({
    type: 'button',
})) `
  appearance: none;
  border: none;
  color: ${theme.semantic.foreground.secondary};
  background-color: ${theme.semantic.surface.primary};
  width: 75%;
  height: 75%;
  border-radius: ${theme.borderRadius.md};
  font-family: inherit;
  font-size: inherit;
  ${(props) => props.$isToday && todayStyle};
  ${(props) => props.$isSelected && selectedDayStyles};
  ${(props) => !props.$isSameMonth && fadedDayStyles};
  ${interactiveTransition};

  &:not(:disabled):focus-visible {
    outline: 0;
    box-shadow: 0 0 0 ${pxToRem(3)} ${theme.semantic.focus.ring};
  }

  &:not(:disabled):hover {
    cursor: pointer;
    color: ${theme.semantic.foreground.primary};
    background-color: ${theme.swatches.gray[100]};
    ${(props) => props.$isSelected && selectedDayStyles};
  }

  &:disabled {
    opacity: 0.5;
  }
`;
export const HeaderContainer = styled.header `
  display: flex;
  align-items: center;
  height: ${pxToRem(42)};
  justify-content: space-between;
  gap: ${theme.spacing.sm};
  padding: ${theme.spacing.md};
  border-bottom: solid ${pxToRem(1)} ${theme.semantic.border.default};
`;
export const Weekdays = styled.div `
  display: flex;
  height: ${pxToRem(14)};
  margin-top: ${theme.spacing.md};
`;
export const Weekday = styled.div `
  flex: 1 1 ${100 / 7}%;
  display: inline-block;
  text-align: center;
  font: ${theme.fontRole.label};
  color: ${theme.semantic.foreground.disabled};
`;
export const DatePickerBody = styled.main `
  display: flex;
  flex-wrap: wrap;
`;
export const YearsList = styled.div `
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(${pxToRem(50)}, 1fr));
  padding-right: ${theme.spacing.xl};
  height: ${pxToRem(200)};
  max-height: ${pxToRem(200)};
`;
export const YearButton = styled.button.attrs(() => ({
    type: 'button',
})) `
  appearance: none;
  border: none;
  margin: ${theme.spacing.xs};
  padding: ${theme.spacing.sm} ${theme.spacing.xs};
  color: ${theme.semantic.foreground.secondary};
  background-color: ${theme.semantic.surface.primary};
  border-radius: ${theme.borderRadius.sm};
  font-family: inherit;
  font-size: ${theme.fontSize.medium};
  ${(props) => props.$isThisYear && todayStyle};
  ${(props) => props.$isSelected && selectedYearStyles};
  ${interactiveTransition};

  &:not(:disabled):focus-visible {
    outline: 0;
    box-shadow: 0 0 0 ${pxToRem(3)} ${theme.semantic.focus.ring};
  }

  &:not(:disabled):hover {
    cursor: pointer;
    color: ${theme.semantic.foreground.primary};
    background-color: ${theme.swatches.gray[100]};
  }

  &:disabled {
    opacity: 0.5;
  }
`;
export const LayoutHelperButton = styled(IconButton).attrs({
    type: 'button',
    size: 'xs',
    role: 'presentation',
}) `
  /* Hack to center the YearPickerToggleButton */
  visibility: hidden;
`;
